import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject } from 'rxjs';
import { ApiResult, PageResult} from '../../../shared/model/Index';
import { tap } from 'rxjs/operators';
import { IStudent } from '@app/modules/compliance/model/student';
import { Guid } from 'guid-typescript';
import { IStudentSearchResult, StudentSearchFilter } from '../model/studentSearchResult';
import { ISearchParam } from '../model/searchParam';


@Injectable({ providedIn: 'root' })

export class StudentSearchService {
    public sharedStudentInfo: IStudent;
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    studentSearch(search:StudentSearchFilter) {
        return this.http.post<ApiResult<PageResult<IStudentSearchResult>>>(env.apiUrl + 'StudentSearch',search).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }    

    studentSearchAPR(search:ISearchParam) {
        return this.http.post<ApiResult<IStudentSearchResult[]>>(env.apiUrl + 'StudentSearch/SearchAPRStudent',search).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }

    globalSearchAPR(search:ISearchParam) {
        return this.http.post<ApiResult<IStudentSearchResult[]>>(env.apiUrl + 'StudentSearch/globalSearch',search).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }   
    
}